import React from 'react';
import styled, { css } from 'styled-components';
import StainedBackground from './stain-background';

const BasicSection = styled.section`
  padding-top: ${({ hideTopSpacing }) => (hideTopSpacing ? '0' : '60px')};
  padding-bottom: ${({ hideBottomSpacing }) => (hideBottomSpacing ? '0' : '60px')};

  ${(props) => (props.darkBackground || props.backgroundColor === 'dark') && css`
    background-color: ${props.theme.grayLightColor};
  `}

  ${(props) => (props.primaryBackground || props.backgroundColor === 'standout') && css`
    background-color: ${props.theme.primaryColor};
  `}
`;

const Section = (props) => {
  if (props?.hideRow) {
    return null;
  }

  if (props.backgroundColor === 'stained') {
    return <StainedBackground {...props} />;
  }

  return <BasicSection {...props} />;
};

export default Section;
